import React, { useEffect, useState } from "react";
import { getMediaUrl } from "../../../utils/api";
import {
  imagenDescripcionMediaPath,
  imagenDescripcionObjectPosition,
} from "../../../utils/focalPoint";
import "./VolcanDescripcion.css";
import { normalizeAdminRichText } from "../../../utils/richText";

function VolcanDescripcion({ volcan }) {
  const [activeSidebar, setActiveSidebar] = useState(null);
  const bannerObjectPosition = imagenDescripcionObjectPosition(volcan);
  const bannerSrc = getMediaUrl(
    imagenDescripcionMediaPath(volcan.imagen_descripcion),
  );
  const productos = Array.isArray(volcan?.productos) ? volcan.productos : [];
  const hasProductos = productos.length > 0;
  const [productoIndex, setProductoIndex] = useState(0);
  const [productoHover, setProductoHover] = useState(false);

  const clampProductoIndex = (next) => {
    if (!hasProductos) return 0;
    const n = productos.length;
    const i = ((next % n) + n) % n;
    return i;
  };

  const productoActual = hasProductos ? productos[productoIndex] : null;

  useEffect(() => {
    if (!hasProductos) return;
    if (productos.length <= 1) return;
    if (productoHover) return;

    const id = window.setInterval(() => {
      setProductoIndex(
        (i) =>
          (((i + 1) % productos.length) + productos.length) % productos.length,
      );
    }, 3500);

    return () => window.clearInterval(id);
  }, [hasProductos, productoHover, productos.length]);

  return (
    <div>
      {bannerSrc && (
        <div className="row">
          <div className="col-12">
            <div className="volcan-banner">
              <img
                src={bannerSrc}
                alt={volcan.title}
                className="w-100 volcan-banner__img"
                style={
                  bannerObjectPosition
                    ? {
                        objectFit: "cover",
                        objectPosition: bannerObjectPosition,
                      }
                    : undefined
                }
              />
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-8 col-md-12">
          <h3 className="seccion-titulo">
            Descripción de la actividad histórica:
          </h3>

          <div
            className="descripcion-texto rich-text"
            dangerouslySetInnerHTML={{
              __html: normalizeAdminRichText(volcan.descripcion),
            }}
          />
        </div>

        <div className="col-lg-4 col-md-12">
          <br></br>
          <div className="sidebar-box">
            {volcan.generalidades_url && (
              <div
                className={`sidebar-item${activeSidebar === "generalidades" ? " is-active" : ""}`}
              >
                <a
                  href={volcan.generalidades_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`sidebar-link${activeSidebar === "generalidades" ? " is-active" : ""}`}
                  onClick={() => setActiveSidebar("generalidades")}
                >
                  <i className="bi bi-file-earmark-text sidebar-icon"></i>
                  <span className="sidebar-text">Generalidades</span>
                </a>
              </div>
            )}

            {volcan.localizacion_url && (
              <div
                className={`sidebar-item${activeSidebar === "localizacion" ? " is-active" : ""}`}
              >
                <a
                  href={volcan.localizacion_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`sidebar-link${activeSidebar === "localizacion" ? " is-active" : ""}`}
                  onClick={() => setActiveSidebar("localizacion")}
                >
                  <i className="bi bi-geo-alt sidebar-icon"></i>
                  <span className="sidebar-text">Localización</span>
                </a>
              </div>
            )}
          </div>

          {hasProductos ? (
            <div className="productos-box">
              <div className="productos-title">Productos</div>
              {(() => {
                if (!productoActual) return null;
                const key = productoActual?.id ?? productoIndex;
                const title = String(productoActual?.title ?? "").trim();
                const pdfUrl = productoActual?.pdf_url
                  ? getMediaUrl(productoActual.pdf_url)
                  : "";
                const imgUrl = productoActual?.imagen
                  ? getMediaUrl(productoActual.imagen)
                  : "";

                return (
                  <div className="productos-carousel">
                    <div
                      className="productos-card"
                      onMouseEnter={() =>
                        setActiveSidebar(`producto:${String(key)}`)
                      }
                      onFocus={() =>
                        setActiveSidebar(`producto:${String(key)}`)
                      }
                      onMouseOver={() => setProductoHover(true)}
                      onMouseOut={() => setProductoHover(false)}
                    >
                      <div className="productos-card__media">
                        {productos.length > 1 ? (
                          <button
                            type="button"
                            className="productos-carousel-btn productos-carousel-btn--prev"
                            aria-label="Producto anterior"
                            onClick={() =>
                              setProductoIndex((i) => clampProductoIndex(i - 1))
                            }
                          >
                            <i className="bi bi-chevron-left" aria-hidden />
                          </button>
                        ) : null}

                        {imgUrl ? (
                          <div className="productos-card__imgwrap">
                            <img
                              className="productos-card__img"
                              src={imgUrl}
                              alt=""
                              loading="lazy"
                            />
                          </div>
                        ) : (
                          <div className="productos-card__imgwrap productos-card__imgwrap--empty">
                            <i className="bi bi-image" aria-hidden />
                          </div>
                        )}

                        {productos.length > 1 ? (
                          <button
                            type="button"
                            className="productos-carousel-btn productos-carousel-btn--next"
                            aria-label="Producto siguiente"
                            onClick={() =>
                              setProductoIndex((i) => clampProductoIndex(i + 1))
                            }
                          >
                            <i className="bi bi-chevron-right" aria-hidden />
                          </button>
                        ) : null}
                      </div>

                      <div className="productos-card__text">
                        {title ? (
                          pdfUrl ? (
                            <a
                              className="productos-card__title"
                              href={pdfUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() =>
                                setActiveSidebar(`producto:${String(key)}`)
                              }
                            >
                              {title}
                            </a>
                          ) : (
                            <div className="productos-card__title productos-card__title--nolink">
                              {title}
                            </div>
                          )
                        ) : null}

                        {productoActual?.descripcion ? (
                          <div
                            className="productos-card__desc rich-text"
                            dangerouslySetInnerHTML={{
                              __html: normalizeAdminRichText(
                                productoActual.descripcion,
                              ),
                            }}
                          />
                        ) : null}

                        {productos.length > 1 ? (
                          <div
                            className="productos-dots"
                            aria-label="Paginación de productos"
                          >
                            {productos.map((_, dotIdx) => (
                              <button
                                key={dotIdx}
                                type="button"
                                className={`productos-dot${dotIdx === productoIndex ? " is-active" : ""}`}
                                aria-label={`Ir al producto ${dotIdx + 1}`}
                                onClick={() => setProductoIndex(dotIdx)}
                              />
                            ))}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default VolcanDescripcion;
